import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`


// WEBPACK FOOTER //
// ./src/pages/Schools/TeacherList/TeacherList.styles.ts